document.addEventListener("DOMContentLoaded", function () {

  const wishlistButtons = document.querySelectorAll(".wishlist-btn, .wishlist-collection-btn");

  const wishlist = JSON.parse(localStorage.getItem("wishlistidita")) || [];

  wishlistButtons.forEach((btn) => {
    const handle = btn.dataset.productHandle;

    // Check if already in wishlist
    if (wishlist.includes(handle)) {
      btn.classList.add("in-wishlist");
      btn.disabled = true; // Only disable if already wishlisted
    }

    // Add click handler only if not already wishlisted
    if (!wishlist.includes(handle)) {
      btn.addEventListener("click", function (event) {
        // Prevent anchor behavior if button is inside an <a>
        event.preventDefault();
        event.stopPropagation();

        wishlist.push(handle);
        localStorage.setItem("wishlistidita", JSON.stringify(wishlist));
        btn.classList.add("in-wishlist");
        btn.disabled = true; // Optional: prevent multiple clicks
        updateWishlistCount();
      });
    }
  });

  function updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem("wishlistidita")) || [];
    const countElem = document.getElementById("wishlist-count");
    if (countElem) {
      countElem.textContent = wishlist.length;
    }
  }

  updateWishlistCount();
});


$(document).on("click", ".add-to-cart-text--added", function () {
  console.log("ATC 1");
  setTimeout(function () {
    const wishlist1 = JSON.parse(localStorage.getItem("wishlistidita")) || [];
    const countElem1 = document.getElementById("wishlist-count");
    if (countElem1) {
      countElem1.textContent = wishlist1.length;
    }
    //console.log("ATC 2"+wishlist1.length);
  }, 2000); // 1000ms = 1 second
});

